import { render } from "./VehicleDetails.vue?vue&type=template&id=057b36b7&scoped=true&ts=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=ts"
export * from "./VehicleDetails.vue?vue&type=script&lang=ts"

import "./VehicleDetails.vue?vue&type=style&index=0&id=057b36b7&lang=scss&scoped=true"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057b36b7"]])

export default __exports__